import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';

class DropDownOptions extends Component {
  static propTypes = {
    filteredOptions: PropTypes.instanceOf(Array),
    activeOptions: PropTypes.instanceOf(Array),
    handleDropdownItemClick: PropTypes.func,
    close: PropTypes.func,
    lazy: PropTypes.bool,
    lazyPageStart: PropTypes.number,
    lazyHasMoreItems: PropTypes.bool,
    lazyLoadMoreItems: PropTypes.func,
  };

  static defaultProps = {
    filteredOptions: [],
    activeOptions: [],
    lazy: false,
  };

  state = {

  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.close();
    }
  }

  render() {
    const {
      filteredOptions,
      activeOptions,
      handleDropdownItemClick,
      lazy,
      lazyPageStart,
      lazyLoadMoreItems,
      lazyHasMoreItems,
    } = this.props;
    let renderDropDownItem = (
      <div className="dd-menu--no-result">No results found.</div>
    );

    if (filteredOptions.length) {
      renderDropDownItem = _.map(filteredOptions, (option, i) => {
        const isItemSelected = _.filter(activeOptions, a => {
          return a.value === option.value;
        }).length === 1;

        const menuItemClass = isItemSelected ? 'dd-menu--item dd-menu--item--active' : 'dd-menu--item';
        if (isItemSelected) {
          return (
            <span
              className={menuItemClass}
              data-value={option.value}
              key={`${option.value}_${i}`}
              title={option.label}
            >
              <span className="dd-menu--label--text">{option.label}</span>
            </span>
          );
        }
        return (
          <button
            className={menuItemClass}
            data-value={option.value}
            key={`${option.value}_${i}`}
            title={option.label}
            onClick={e => handleDropdownItemClick(e, option)}
          >
            <span className="dd-menu--label--text">{option.label}</span>
          </button>
        );
      });
    }
    let returnComponentValue = renderDropDownItem;
    if (lazy) {
      returnComponentValue = (
        <InfiniteScroll
          pageStart={lazyPageStart}
          loadMore={lazyLoadMoreItems}
          hasMore={lazyHasMoreItems}
          useWindow={false}
          threshold={20}
          loader={<div className="loader" key={0}>Loading ...</div>}
        >
          {renderDropDownItem}
        </InfiniteScroll>
      );
    }

    return (
      <div className="dd-menu--wrapper">
        {returnComponentValue}
      </div>
    );
  }
}

export default DropDownOptions;
